<script setup lang="ts">
import {faCreditCardFront} from '@fortawesome/pro-light-svg-icons';

const reloadPage = () => {
  window.location.reload();
};
</script>

<template>
  <p class="stripe-error mb-4">
    <font-awesome-icon class="mr-1" :icon="faCreditCardFront" />
    Your browser is blocking other payment methods.
    <tml-anchor
      text="Try refreshing the page."
      @click="reloadPage"
    />
  </p>
</template>